'use client';

import { Suspense } from 'react';
import Link from 'next/link';
import { useSearchParams } from 'next/navigation';

import { AuthOtpForm } from '@/components/auth/otp-form';

export default function LoginPage() {
  return (
    <Suspense fallback={null}>
      <LoginContent />
    </Suspense>
  );
}

function LoginContent() {
  const searchParams = useSearchParams();
  const returnTo = searchParams.get('returnTo') ?? undefined;

  return (
    <div className="flex min-h-[80vh] flex-col items-center justify-center px-6 py-16">
      <AuthOtpForm mode="login" returnTo={returnTo} />
      <p className="mt-8 text-sm text-muted-foreground">
        Need an account?{' '}
        <Link className="text-primary underline hover:text-primary/80" href="/auth/signup">
          Sign up
        </Link>
      </p>
    </div>
  );
}
